module.exports = __webpack_public_path__ + "img/QR_teacher.8d34e808.png";